import { render, staticRenderFns } from "./CaratsTable.vue?vue&type=template&id=c554443c&"
import script from "./CaratsTable.vue?vue&type=script&lang=js&"
export * from "./CaratsTable.vue?vue&type=script&lang=js&"
import style0 from "./CaratsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2065084294/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c554443c')) {
      api.createRecord('c554443c', component.options)
    } else {
      api.reload('c554443c', component.options)
    }
    module.hot.accept("./CaratsTable.vue?vue&type=template&id=c554443c&", function () {
      api.rerender('c554443c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CaratsTable.vue"
export default component.exports